var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/FamilyBlue.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FamilyBlue = ({
  color = '#4C5ECF',
  ...other
}) => /*#__PURE__*/_jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: [/*#__PURE__*/_jsx("rect", {
    opacity: "0.1",
    width: "24",
    height: "24",
    rx: "4",
    fill: "#2235AA"
  }), /*#__PURE__*/_jsx("rect", {
    opacity: "0.5",
    x: "5",
    y: "13",
    width: "6",
    height: "6",
    rx: "1",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    opacity: "0.5",
    x: "9",
    y: "5",
    width: "6",
    height: "6",
    rx: "1",
    fill: color
  }), /*#__PURE__*/_jsx("rect", {
    opacity: "0.5",
    x: "13",
    y: "13",
    width: "6",
    height: "6",
    rx: "1",
    fill: color
  })]
});